import React, { useContext } from 'react';
import Navbar from './components/navbar';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import PlayCircleIcon from '@material-ui/icons/PlayCircleFilled';
import { useHistory } from 'react-router-dom';
import { PayloadContext } from '../../context';
import { getMyActiveLicenses } from '../../actions/license';
import { toast } from 'react-toastify';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';

const HomeLayout = (WRC) =>
{
	const NewComponent = () =>
	{
		const path = window.location.pathname;

		const { payload, getPayload } = useContext(PayloadContext);

		const history = useHistory();

		const handleRoute = (pathName) =>
		{
			if (path !== pathName)
			{
				history.push(pathName);
			}
		};

		const handleLogout = () =>
		{
			localStorage.removeItem('userAuthToken');
			getPayload();
			history.push('/');
		};

		const handleStartMeeting = () =>
		{
			if (payload && payload.plan)
			{
				getMyActiveLicenses().then((res) =>
				{
				// eslint-disable-next-line no-console
					// console.log('res ==== ', res);
					if (res && res.status && res.data.data && res.data.data.length > 0)
					{
						history.push(`/meet/${res.data.data[0]._id}`);
					}
					else
					{
						toast.error('Please activate your licenses');
					}
				})
					.catch((err) =>
					{
						// eslint-disable-next-line no-console
						console.log('err ==== ', err);
						toast.error('Internal server error, Please try again');
					});
			}
		};

		return (
			<div className='flexCol baseBg fullHeight'>
				<Navbar />
				<div className='flexRow bodyCntnr'>
					{path !== '/dashboard' &&
					<div className='flexAutoCol width20 width65 overflow-y-auto vh-100-cal-64'>
						<div className='sidebar'>
							<nav>
								<ul className='ul bg-black'>
									<div className='flexMinWidthCol'>
										<li className={path=='/dashboard'?'activeLi li':'li'} onClick={() => handleRoute('/dashboard')}>
											<div>
												<AccountBalanceIcon/>
												<span>Account Center</span>
											</div>
										</li>
										{payload?.userType === 'Admin' && <li className={path=='/users'?'activeLi li':'li'} onClick={() => handleRoute('/users')}>
											<div>
												<PeopleIcon/>
												<span>User Management</span>
											</div>
										</li>}
										{payload?.userType === 'Admin' && <li className={path=='/package-management'?'activeLi li':'li'} onClick={() => handleRoute('/package-management')}>
											<div>
												<WorkIcon/>
												<span>Package Management</span>
											</div>
										</li>}

										{/* {path === '/activation' ? */}
										<li className='li' onClick={() => handleStartMeeting()}>
											<div>
												<MeetingRoomIcon />
												<span>Quick Start a Session</span>
											</div>
										</li>
										{/* // 	:
										// 	<li className='li' onClick={() => handleRoute('/activation')}>
										// 		<div>
										// 			<VpnKeyIcon/>
										// 			<span>Activate License(s)</span>
										// 		</div>
										// 	</li>
										// } */}
										<li className={path=='/activation'?'activeLi li':'li'} onClick={() => handleRoute('/activation')}>
											<div>
												<Inventory2OutlinedIcon/>
												<span>Products</span>
											</div>
										</li>
										<li className={path=='/schedule'?'activeLi li':'li'} onClick={() => handleRoute('/schedule')}>
											<div>
												<DateRangeIcon/>
												<span>Schedule Meetings</span>
											</div>
										</li>
										<li className={path=='/address-book'?'activeLi li':'li'} onClick={() => handleRoute('/address-book')}>
											<div>
												<FormatListBulletedIcon/>
												<span>Address Book</span>
											</div>
										</li>
										<li className={path=='/user-profile'?'activeLi li':'li'} onClick={() => handleRoute('/user-profile')}>
											<div>
												<AccountCircleIcon/>
												<span>My Profile</span>
											</div>
										</li>
										{/* <li className={path=='/watch-videos'?'activeLi li':'li'} onClick={() => handleRoute('/watch-videos')}>
											<div>
												<PlayCircleIcon/>
												<span>Watch Videos</span>
											</div>
										</li> */}
									</div>
									<div className='flexAutoCol'>
										<li className='li' onClick={() => handleLogout()}>
											<div>
												<ExitToAppIcon/>
												<span>Log out</span>
											</div>
										</li>
									</div>
								</ul>
							</nav>
						</div>
					</div>}
					<div className={`flexRow justifyCntr alignStrt ${path !== '/dashboard' ? 'width65 overflow-y-auto vh-100-cal-64' : 'fullWidth'}`}>
						<WRC />
					</div>
				</div>
			</div>
		);
	};

	return NewComponent;
};

export default HomeLayout;
